import api from "./api";

export function getVisaDocumentPage(country_id) {
  return api.get(`/visadocument/${country_id}`);
}
